import React from "react";

import {
  CityConfig,
  CityConfigService,
  Sector,
  Zone,
} from "@egis-smartcity/parking";

export type CityConfigState = {
  cityConfigService?: CityConfigService;
  cityConfig?: CityConfig;
  sectors?: Sector[];
  zones?: Zone[];
};

export const CityConfigContext = React.createContext<
  CityConfigState | undefined
>(undefined);

export default CityConfigContext;
